// Generated by Melange

import ArtistsPageModuleCss from "./artistsPage.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Shared__ArtistCard from "../shared/artistCard.jsx";
import * as Shared__CardGrid from "../shared/cardGrid.jsx";
import * as Shared__Container from "../shared/container.jsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = ArtistsPageModuleCss;

function ArtistsPage(Props) {
  let listIds = Props.listIds;
  return JsxRuntime.jsx(Shared__Container.make, {
    children: JsxRuntime.jsx(Shared__CardGrid.make, {
      children: listIds.map(function (id, i) {
        const Key = String(i);
        let tmp = {
          coverArtSizes: Shared__CardGrid.card_grid_cover_art_sizes,
          loadCoverArtLazily: true
        };
        if (id !== undefined) {
          tmp.id = Caml_option.valFromOption(id);
        }
        return JsxRuntime.jsx(Shared__ArtistCard.make, tmp, Key);
      })
    }),
    className: css.root
  });
}

const make = ArtistsPage;

export {
  make,
}
/* css Not a pure module */
